import { useReduxState } from 'hooks';
import {
  ContentLabel,
  ContentValue,
  ModalButton,
  User
} from 'components/common';

import type { UserWithBasicData } from 'shared-types';

interface Props {
  user: UserWithBasicData;
  userAttributes: { [key: string]: any };
}

const CalendarEventParticipantsAttributes = ({
  user,
  userAttributes
}: Props) => {
  const {
    language,
    messages,
    pageState: { calendarEvent }
  } = useReduxState();

  return (
    <ModalButton
      category="lighter"
      isRounded={true}
      modalProps={{
        closeButton: true,
        title: messages.eventCalendarParticipantData,
        width: 'medium'
      }}
      size="small"
      style={{
        padding: '4px 9px 5px'
      }}
      text={messages.commonViewAction}
    >
      <div>
        <User user={user} />
      </div>
      <div style={{ marginTop: 20 }}>
        {calendarEvent.userAttributes.map((attr) => {
          const title = attr.titleTranslations?.[language] || attr.title;
          const value = userAttributes?.[attr.id];

          return (
            <ContentLabel
              horizontal={true}
              horizontalSpacing={50}
              key={attr.id}
              label={title}
            >
              <ContentValue style={{ fontWeight: 600 }}>
                {attr.type === 'Boolean' && value !== undefined
                  ? value
                    ? messages.commonYes
                    : messages.commonNo
                  : Array.isArray(value) && value.length
                  ? value.join(', ')
                  : value || '-'}
              </ContentValue>
            </ContentLabel>
          );
        })}
      </div>
    </ModalButton>
  );
};

export default CalendarEventParticipantsAttributes;
